import { LoadingIcon } from '@assets/icons';
import { Typography } from '@components/typography';
import { useGetDatasetModelsQuery } from '@generated/graphql';
import { useOrganizationContext } from '@navigation/OrganizationContext';
import { navigate } from 'gatsby';
import posthog from 'posthog-js';
import { DatasetDetailsAccordion } from '../../DatasetDetailsAccordion';
import {
  DatasetDetailsModelsListHeader,
  DatasetDetailsModelsListItem,
} from './DatasetDetailsModelsListItem';

export const DatasetDetailsModelsList = ({
  datasetId,
  workspaceId,
}: {
  datasetId: string;
  workspaceId: string;
}) => {
  const { organizationId } = useOrganizationContext();
  const { data, loading, refetch } = useGetDatasetModelsQuery({
    variables: { datasetId, workspaceId },
  });
  const models = data?.getMLModels || [];

  return (
    <DatasetDetailsAccordion
      title="Models"
      details={
        loading ? (
          <LoadingIcon size={8} />
        ) : models.length === 0 ? (
          <Typography variant="caption2" noWrap>
            This dataset has no inferences.
          </Typography>
        ) : (
          <>
            <DatasetDetailsModelsListHeader />
            {models.map((model) => (
              <DatasetDetailsModelsListItem
                key={model.modelId}
                datasetId={datasetId}
                workspaceId={workspaceId}
                refetch={refetch}
                {...model}
              />
            ))}
          </>
        )
      }
      count={!loading ? models.length : null}
      onCreate={() => {
        posthog.capture('user_create-ml-model_intent', { source: 'dataset' });
        void navigate(
          `/${organizationId}/workspaces/${workspaceId}/experiments/createModel?datasetId=${datasetId}`,
        );
      }}
    />
  );
};
